export const entity =
    {
        name: 'PointsOfAttention',
        facets: [
            {name: 'codeName', uniqueCode: true}
        ]
    }


export const module_ = {
    object: 'PointsOfAttention',
    category: {
        path: 'paramétrage',
        icon: 'settings'
    },
    defaultSortBy: 'code',
    defaultSortDirection: 'ASC',
    tKey: `point d'attention`,
    viewMap: {
        dt: [
           'code',
           'name'
        ],
        form: [
            'code',
            'name'
        ]
    }
}